<template>
    <form-row title="Have You Scheduled Your Closing?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="have_scheduled_closing"
                v-model="have_scheduled_closing"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="have_scheduled_closing"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Confirmed Closing Date:"
                :value="closing.confirmed_closing_date"
                name="confirmed_closing_date"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        closing: {},
        read_only: { default: false },
    },

    data() {
        return {
            have_scheduled_closing: this.closing.have_scheduled_closing,
        }
    },
}
</script>
